export const CHURCH_INFO = {
  email: "trinitycchurch2013@gmail.com",
  phoneDisplay: "(734) 720-7189",
  phoneHref: "tel:+17347207189",
  addressLine1: "20330 Superior Rd",
  addressLine2: "Taylor, MI 48180",
  websiteUrl: "https://www.trinity-cc.org",
  websiteLabel: "www.trinity-cc.org",
};
